export default __webpack_public_path__ + "62a706e7bd06e5a1edc1878ed8dfbd14.png";